<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content" id="detail-content">
        <el-row>
          <div class="header-title">发放明细</div>
        </el-row>
        <!-- <el-row class="center">
            <el-col :span="10">
              <p class="title text-center">{{ this.baseInfo.name }}</p>
              <el-alert class="desc" type="warning" :closable="false" id="el-alert">
                <template slot="title">
                  <div>系统提示：</div>
                  <div>1、单个批次模板数据不能超过1000条</div>
                  <div v-if="type == 'send'">2、如果需要提交数据请滑动最底部点击按钮</div>
                </template>
              </el-alert>
            </el-col>
          </el-row> -->

        <el-row id="detail-table">
          <ApeTable
            ref="apeTable"
            :data="statusList"
            :columns="columnsStatus"
            :loading="loadingStaus"
            highlight-current-row
          >
          </ApeTable>
        </el-row>
        <el-row class="export">
          <div class="export-left">
            <el-col class="total-wrapper">
              <div class="total-left">总笔数：</div>
              <div class="total-right">
                {{ this.totalNumber }}
                <span class="total-right bi">笔</span>
              </div>
            </el-col>
            <el-col class="total-wrapper">
              <div class="total-left">总金额：</div>
              <div class="total-right">
                {{ this.totalPrice }}
                <span class="total-right bi">元</span>
              </div>
            </el-col>
            <el-col class="total-wrapper">
              <div class="total-left">预抵扣税费合计：</div>
              <div class="total-right">
                {{ this.now_tax_money }}
                <span class="total-right bi">元</span>
              </div>
            </el-col>
          </div>
          <el-col class="table-right">
            <el-form style="height: 40px; line-height: 40px" :inline="true">
              <el-form-item>
                <el-select
                  v-model="stateValue"
                  @change="selectState"
                  class="select-state-box"
                >
                  <el-option
                    v-for="item in stateOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>

            <div class="export-wrapper">
              <el-select
                v-model="value"
                @change="selectData"
                class="select-box"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-button
                :loading="downloadLoading"
                type="primary"
                class="export-table"
                size="medium"
                icon="el-icon-document"
                @click="handleDownload"
              >
                导出
              </el-button>
			<el-button style="margin-left: 10px;" :loading="dianzi_downloadLoading" size="medium" type="primary" @click="dowloadDZHD">导出电子回单</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row id="detail-table">
          <ApeTable
            ref="batchapeTable"
            :data="dataList"
            :columns="columns"
            :loading="loadingStaus"
            :pagingData="pagingData"
            @switchPaging="switchPaging"
            highlight-current-row
          >
            <el-table-column prop="alias_code" label="银行回馈码">
              <template slot-scope="scope">
                <el-tag
                  :type="
                    scope.row.alias_code === '-'
                      ? 'info'
                      : scope.row.alias_code === '0000'
                      ? 'success'
                      : 'danger'
                  "
                  >{{ scope.row.alias_code }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="alias_msg" label="银行回馈消息">
              <template slot-scope="scope">
                <div
                  :style="
                    scope.row.alias_msg === '未处理'
                      ? 'color: #909399'
                      : scope.row.alias_msg === '已发放'
                      ? 'color: #67c23a'
                      : 'color: #f56c6c'
                  "
                >
                  {{ scope.row.alias_msg }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="alias_msg" label="电子回单">
              <template slot-scope="scope">
                <el-button
                  size="medium"
                  @click="
                    mxViewReceipt(scope.row.outer_trade_no, baseInfo.yl_bank,scope.row.ele_receipt_url)"
                  type="success"
                  plain
                  >下载电子回单
                </el-button>
                <!-- v-if="baseInfo.yl_bank != 'alipay'" -->
                <!-- <el-button size="medium" v-else type="info" disabled plain>支付宝不支持</el-button> -->
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="goAmountEdit(scope.row)">
                  修改金额
                </el-button>
              </template>
            </el-table-column>
          </ApeTable>
        </el-row>
        <el-row v-if="type == 'send'" class="center">
          <el-col class="text-center" :span="10">
            <el-button type="primary" size="medium" @click="handleSubmit"
              >请仔细检查数据，确认无误后提交此表格</el-button
            >
          </el-col>
        </el-row>
      </div>
    </PageHeaderLayout>
    <verification
      @dialogChanged="dialogChanged($event)"
      @onSuccess="handleSuccess($event)"
      :dialogVisible="dialogVisible"
    />
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import ApeDrawer from "@/components/ApeDrawer";
import ApeUploader from "@/components/ApeUploader";
import ModalDialog from "@/components/ModalDialog";
import Verification from "@/components/Verification";
import DatePicker from "@/components/DatePicker.vue";
import { mapGetters } from "vuex";
import {MessageBox} from 'element-ui'

const AMOUNT_OVERRIDE_PREFIX = "dailySettlementAmountOverride";
const AMOUNT_SEED_PREFIX = "dailySettlementAmountSeed";

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    Verification,
    DatePicker,
  },
  data() {
    return {
      isLaowuCompany:false,
      now_tax_money:0,
      //发放状态
      stateOptions: [
        {
          value: "",
          label: "全部发放状态",
        },
        {
          value: "00",
          label: "未处理",
        },
        {
          value: "02",
          label: "发放失败",
        },
        {
          value: "11",
          label: "已发放",
        },
      ],
      stateValue: "全部发放状态",
      totalNumber: "",
      totalPrice: "",
      // idcard: '',
      dialogVisible: false,
      downloadLoading: false,
      id: 0,
      // element的cascader的props值
      cascaderProps: {
        label: "display_name",
        value: "id",
      },
      type: "",
      tableData: [],
      tableHeader: [],
      searchCategory: [],
      taskList: [],
      // 搜索条件
      searchCondition: {},
      loadingStaus: true,
      //导出格式
      options: [
        {
          value: "xlsx",
          label: "xlsx",
        },
        {
          value: "csv",
          label: "csv",
        },
        {
          value: "txt",
          label: "txt",
        },
      ],
      value: "xlsx",
      //导出表格类型
      bookType: "xlsx",
      columnsStatus: [
        {
          title: "结算笔数",
          value: "total_num",
        },
        {
          title: "结算金额",
          value: "total_amount",
        },
        {
          title: "成功笔数",
          value: "succeed_num",
        },
        {
          title: "成功金额",
          value: "succeed_money",
        },
        {
          title: "失败笔数",
          value: "failed_num",
        },
        {
          title: "失败金额",
          value: "failed_money",
        },
      ],
      statusList: [],
      columns: [
        {
          title: "姓名",
          value: "bank_account_name",
        },
        {
          title: "收款账号",
          value: "bank_account_no",
        },
        {
          title: "下发通道",
          value: "yl_bank",
        },
        // {
        //   title: "证件类型",
        //   value: "alias_id_type",
        // },
        // {
        //   title: "证件号码",
        //   value: "id_number",
        // },
        // {
        //   title: "手机号码",
        //   value: "mobile",
        // },
        {
          title: "附属信息",
          width: 300,
          value: [
            { label: "证件类型：", value: "alias_id_type" },
            { label: "证件号码：", value: "id_number" },
            { label: "手机号码：", value: "mobile" },
            { label: "银行名称：", value: "bank_name" },
            { label: "编码：", value: "code" },
            { label: "下发时间：", value: "notify_time" },
          ],
          header_align: "center",
          /*   align: 'center', */
        },
        {
          title: "结算金额",
          value: "money",
        },
        {
          title: "实收金额",
          value: "after_money",
        },
        {
          title: "个税",
          value: "now_tax_money",
        },{
		title: "预扣增值税和附加税",
		value: "added_tax_money",
		header_align: "center",
		align: "center",
		width: 180,
		},
        /*  {
           title: "银行回馈码",
           value: "alias_code",
           color: '',
           fontWeight: 'bold'
         },
         {
           title: "银行回馈消息",
           value: "alias_msg",
           color: '',
           fontWeight: 'bold'
         }, */
      ],
      idcard: "",
      // 表格列表数据
      baseInfo: {},
      dataList: [],
      //导出表格数据
      exportList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, prev, pager, next',
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      // 已上传文件列表
      uploadFileList: [],
      // 表单验证

      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: "正在加载中……",
        // direction: 'right',
        title: "",
        width_height: "640px",
        show_footer: false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 附件列表
      attachmentList: [],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: "标题",
          value: "title",
        },
      ],
      // 添加附件
      dialogData: {
        visible: false,
        title: "",
        width: "24%",
        loading: true,
        modal: false,
      },
      // 附件表单内容
      formData: {},
      // 附件添加表单验证
      dialogRules: {
        title: [{ required: true, message: "输入标题", trigger: "blur" }],
      },
      // 附件类型
      attachmentType: [
        "application/pdf",
        "application/caj",
        "",
        "application/zip",
        "application/rar",
        "application/doc",
      ],
      // 已上传附件列表
      attachmentUploadFileList: [],
      // 当前需要操作附件的文章id
      currentCompanyId: 0,
	dianzi_downloadLoading:false,
	errCount:0,
    };
  },
  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
  },
  watch: {
    idcard(val) {
      this.idcard = val;
    },
  },
  methods: {
    getRecordIdentity(record = {}) {
      return (
        record.id ||
        record.detail_id ||
        record.customer_id ||
        record.user_id ||
        record.id_number ||
        ""
      );
    },
    getAmountSeedKey(batchId, detailId) {
      return `${AMOUNT_SEED_PREFIX}:${batchId}:${detailId}`;
    },
    getAmountOverridePrefix(batchId) {
      return `${AMOUNT_OVERRIDE_PREFIX}:${batchId}:`;
    },
    formatAmount(value) {
      if (value === "" || value === null || value === undefined) {
        return "";
      }
      const num = Number(value);
      if (Number.isNaN(num)) {
        return "";
      }
      return num.toFixed(2).replace(/\.?0+$/, "");
    },
    sumMoney(list = []) {
      const total = list.reduce((sum, item) => {
        const current = Number(item.money);
        return Number.isNaN(current) ? sum : sum + current;
      }, 0);
      return this.formatAmount(total);
    },
    getAmountOverrideMap(batchId) {
      const map = {};
      const prefix = this.getAmountOverridePrefix(batchId);
      for (let i = 0; i < window.sessionStorage.length; i += 1) {
        const key = window.sessionStorage.key(i);
        if (!key || key.indexOf(prefix) !== 0) {
          continue;
        }
        try {
          const value = JSON.parse(window.sessionStorage.getItem(key));
          if (value && value.detail_id) {
            map[String(value.detail_id)] = value;
          }
        } catch (error) {
          console.log(error);
        }
      }
      return map;
    },
    applyLocalAmountOverrides(list = []) {
      const overrideMap = this.getAmountOverrideMap(this.id);
      return list.map((item) => {
        const detailId = String(this.getRecordIdentity(item));
        const override = overrideMap[detailId];
        if (!override) {
          return item;
        }
        return {
          ...item,
          salary_type: override.salary_type || item.salary_type,
          money: override.settlement_amount || item.money,
          unit_amount: override.unit_amount || item.unit_amount,
        };
      });
    },
    goAmountEdit(row) {
      const detailId = this.getRecordIdentity(row);
      if (!detailId) {
        this.$message.error("缺少人员标识，无法修改金额");
        return;
      }
      window.sessionStorage.setItem(
        this.getAmountSeedKey(this.id, detailId),
        JSON.stringify({
          baseInfo: this.baseInfo,
          detailInfo: row,
        })
      );
      this.$router.push(
        `${this.$route.matched[1].path}/${this.id}/edit-amount/${detailId}`
      );
    },
	async downFile  (pdfUrl,fileName)  {
	try {
	const res = await fetch(pdfUrl);
	if (!res.ok) {
	this.errCount+=1
	if(this.errCount===this.exportList.length){
	MessageBox.alert(`当前页面电子回单暂未生成`, '系统提示', {
	confirmButtonText: '确定',
	type: 'error',
	})
	}
	throw new Error(`Failed to fetch PDF: ${res.status} ${res.statusText}`);
	}
	console.log(res)
	const blob = await res.blob();
	const url = URL.createObjectURL(blob); // 传入用于创建 URL 的 File 对象、Blob,转换成浏览器可识别的blob格式
	console.log('url---',url); //blob:http://127.0.0.1:5500/f01dc675-8f01-4e47-9313-65b96321884f
	// 创建a标签，绑定href、download属性，添加在body，触发click事件
	const link = document.createElement('a');
	link.href = url;
	link.download = fileName+'.pdf' || 'downloaded.pdf';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link); // 移除元素
	URL.revokeObjectURL(url); // 当不再需要这些 URL 对象时,通过它释放掉
	} catch (error) {
	console.log(error)
	}
	
	},
	async dowloadDZHD(){
	this.dianzi_downloadLoading=true
	let urls=[]
	this.exportList.map(item=>{
		let url=''
		if(item.ele_receipt_url){
		url = item.ele_receipt_url
		}else{
		url = `${this.$config.ossDomain}/${this.$config.ossAppDir}/e-receipt/${item.outer_trade_no}.pdf`
		}
		urls.push(url)
	})
	try{
		let result = await this.$api.postExportReceipt({urls});
		if(result){
			window.open(result,'_blank')
		}
	}catch(e){
		//TODO handle the exception
		console.log(e)
	}finally{
		this.dianzi_downloadLoading=false
	}
	
	
	},
    async handleSuccess() {
      const res = await this.$api.sendTask({
        batch_id: this.baseInfo.id,
      });
      if (res) {
        this.$message.success("提交成功，请等待系统审核!");
        this.goBack();
      }
    },
    //返回上一页
    goBack() {
      this.$router.push(this.$route.matched[1].path);
    },
    dialogChanged(state) {
      this.dialogVisible = state;
    },
    // 表单提交
    handleSubmit() {
      if (this.dataList.length <= 0) {
        return this.$message.error("提交失败，数据不能为为空!");
      }
      this.dialogVisible = true;
    },
    //选择发放状态
    selectState(e) {
      this.searchCondition.send_status = e;
      if (!this.searchCondition.send_status) {
        delete this.searchCondition.send_status;
      }
      this.init("search");
    },
    //选择导出表格格式
    selectData(e) {
      this.bookType = e;
    },
    //导出表格数据
    async handleDownload() {
      this.downloadLoading = true;
      import("@/excel/Export2Excel").then(async(excel) => {
        let sHeader_arr = {
          code: "【编码（选填,20位以内）】",
          name: "【姓名】",
          cardType: "【证件类型(1:身份证2:港澳台通行证3：护照4：军官证)】",
          idCard: "【身份证号码】",
          phone: "【手机号码】",
          bankCard: "【账号(银行卡号或支付宝邮箱账号)】",
          bankName:"【银行名称（选填）】",
          accountName:"【银行卡开户行名称（选填）】",
          // money:"【税后金额(单位元)】",
          moneyType:"【金额类型(税前;税后)】",
          remark:"【备注】",
          type: "【下发类型(OTHERBANK:银行卡;ALIPAY:支付宝)】",
          money: "【结算金额】",
          after_money:"【实收金额】",
          now_tax_money:"【个税】",
		added_tax_money:"【预扣增值税和附加税】",
          notify_time: "【下发时间】",
          alias_code:"【银行回馈码】",
          alias_msg:"【银行回馈消息】",
        };

        if(this.isLaowuCompany){
          sHeader_arr = {
            code: "【编码（选填,20位以内）】",
            name: "【姓名】",
            cardType: "【证件类型(1:身份证2:港澳台通行证3：护照4：军官证)】",
            idCard: "【身份证号码】",
            phone: "【手机号码】",
            bankCard: "【账号(银行卡号或支付宝邮箱账号)】",
            bankName:"【银行名称（选填）】",
            accountName:"【银行卡开户行名称（选填）】",
            moneyType:"【金额类型(税前;税后)】",
            remark:"【备注】",
            type: "【下发类型(OTHERBANK:银行卡;ALIPAY:支付宝)】",
            money: "【实收金额】",
            notify_time: "【下发时间】",
            alias_code:"【银行回馈码】",
            alias_msg:"【银行回馈消息】",
            personal_income_tax:"【个税】",
            value_added_tax:"【增值税】",
            additional_tax:"【附加税】"
          }
        }
        let tHeader = Object.keys(sHeader_arr)
        const data = this.formatJson(this.exportList);
        data.unshift(Object.values(sHeader_arr));
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `发放明细${time}`;
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map((v) => {
        if(this.isLaowuCompany){
          let {
            code,
            bank_account_name,
            id_type,
            id_number,
            mobile,
            bank_account_no,
            bank_name,
            bank_branch,
            remark,
            send_type,
            money_type,
            money,
            notify_time,
            alias_code,
            alias_msg,
            personal_income_tax,
            value_added_tax,
            additional_tax
          } = v;
          return [
          code,
            bank_account_name,
            id_type,
            id_number,
            mobile,
            bank_account_no,
            bank_name,
            bank_branch,
            money_type,
            remark,
            send_type,
            money,
            notify_time,
            alias_code,
            alias_msg,
            personal_income_tax,
            value_added_tax,
            additional_tax
          ];
        }else{
          let {
            code,
            bank_account_name,
            id_type,
            id_number,
            mobile,
            bank_account_no,
            bank_name,
            bank_branch,
            remark,
            send_type,
            money,
            after_money,
            now_tax_money,
			added_tax_money,
            notify_time,
            alias_code,
            alias_msg,
          } = v;
          return [
            code,
            bank_account_name,
            id_type,
            id_number,
            mobile,
            bank_account_no,
            bank_name,
            bank_branch,
            '税前',
            remark,
            send_type,
            money,
            after_money,
            now_tax_money,
			added_tax_money,
            notify_time,
            alias_code,
            alias_msg,
          ];
        }
        
      });
    },
    // 是否是劳务公司
    async getIsLaoWu(){
      let settlementList = await this.$api.getUserSettlement({
        company_id:JSON.parse(localStorage.getItem('nowCompany')).id
      })
      // console.log(settlementList)
      let companyIds = JSON.parse(localStorage.getItem('user_info')).settlement_id.replaceAll(/"/g,'')
      let newSettlementList = Object.assign(settlementList, [])
      
      newSettlementList.map(item=>{
        if(item.id == companyIds){
          if(item.is_labor_dispatch != 0){
            this.isLaowuCompany = true
          }
        }
      })
      
      console.log(this.isLaowuCompany,'返回标识')
      if(this.isLaowuCompany){
        this.columns = [
          {
            title: "姓名",
            value: "bank_account_name",
          },
          {
            title: "收款账号",
            value: "bank_account_no",
          },
          {
            title: "下发通道",
            value: "yl_bank",
          },
          {
            title: "附属信息",
            width: 300,
            value: [
              { label: "证件类型：", value: "alias_id_type" },
              { label: "证件号码：", value: "id_number" },
              { label: "手机号码：", value: "mobile" },
              { label: "银行名称：", value: "bank_name" },
              { label: "编码：", value: "code" },
              { label: "下发时间：", value: "notify_time" },
            ],
            header_align: "center",
            /*   align: 'center', */
          },
          {
            title: "实收金额",
            value: "money",
          },
          {
            title:"增值税",
            value:"value_added_tax"
          },
          {
            title:"附加税",
            value:"additional_tax"
          },
          {
            title:"个税",
            value:"personal_income_tax"
          }
        ]
      }
    },
    // 初始化列表
    async init(type) {
      this.id = this.$route.params.batch_id;
      if (this.id) {
        this.loadingStaus = true;
		// let pagingInfo = this.$refs["batchapeTable"]?.getPagingInfo(type)||{};
        let args = {
          id: this.id,
        };
        let searchCondition = this.handleSearchCondition();
        Object.assign(searchCondition, args);
        let { base, detail,pages,info } = await this.$api.getTaskInfo(searchCondition);
        this.dataList = this.applyLocalAmountOverrides(detail);
        const totalPrice = this.sumMoney(this.dataList);
        this.baseInfo = {
          ...base,
          total_amount: totalPrice || base.total_amount,
        };
        this.statusList = [this.baseInfo];
        this.getIsLaoWu()

        // 修改下发银行信息
        for (let i = 0; i < this.dataList.length; i++) {
          this.dataList[i].yl_bank = this.baseInfo.yl_bank;
          switch (this.baseInfo.yl_bank) {
            case "alipay":
              this.dataList[i].yl_bank = "支付宝";
              break;
            case "pingan":
              this.dataList[i].yl_bank = "银行";
              break;
            case "sj":
              this.dataList[i].yl_bank = "银行";
              break;
            case "wechat":
              this.dataList[i].yl_bank = "微信";
              break;
            case "ws":
              this.dataList[i].yl_bank = "银行";
              break;
            case "wssft":
            this.dataList[i].yl_bank = "银行";
            break;
            default:
          }
        }

        this.totalNumber = info.count;
        this.totalPrice = totalPrice || info.money;
        this.now_tax_money = info.now_tax_money;
        this.exportList = this.dataList;
        
        this.pagingData.total = pages.total;
        let pagingInfo = this.$refs['batchapeTable'].getPagingInfo(type)
        this.pagingData.total = this.dataList.length
        this.offset += 10
        this.dataList=  this.dataList.slice(pagingInfo.current_page * 10 - 10, pagingInfo.current_page * 10)
        
      }
      this.loadingStaus = false;
    },
    // 切换页码操作
    switchPaging() {
      this.init();
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.send_status) {
        condition.send_status = this.searchCondition.send_status;
      }
      return condition;
    },

    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = "正在提交中……";
      this.dialogData.loading = true;
      this.formData.company_id = this.currentCompanyId;
      let id = await this.$api.saveCompanyAttachment(this.formData);
      this.$nextTick(() => {
        this.dialogClose();
      });
      this.$nextTick(() => {
        if (id) {
          this.initCompanyAttachmentList();
        }
      });
      this.$nextTick(() => {
        this.$message.success("保存成功!");
      });
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs["companyAttacmentForm"].validate((valid) => {
        if (valid) {
          this.formSubmit();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false;
      this.dialogData.loading = true;
      this.formData = {};
      this.attachmentUploadFileList = [];
    },
  },
  updated() {
    this.type = this.mxGetQuery("type") || "view";
    if (this.type != "view") {
      this.$refs["batchapeTable"].handleCurrentChange(1);
    }
  },
  created() {
    // this.type = this.mxGetQuery('type') || 'view'
    this.init();  
  },
};
</script>

<style lang="stylus" scoped>
.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.table-header {
  margin-bottom: 12px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0px;
  margin-right: 12px;
}

.submitBtn {
  float: right;
  margin-top: 20px;
}

.link-url {
  color: #fff;
  text-decoration: none;
}

.title {
  font-size: 32px;
}

.desc {
  margin-bottom: 30px;
}

.center {
  display: flex;
  justify-content: center;
}

.text-center {
  text-align: center;
}

.header-title {
  height: 53px;
  line-height: 53px;
  background-color: #1890ff;
  color: #fff;
  font-size: 20px;
  text-align: center;
}

#detail-content {
  padding: 0;
  padding-bottom: 24px;
}

#detail-table {
  padding: 0 24px;
}

.detail-search {
  padding: 0 24px;
  height: 50px;
  padding-top: 10px;
}

.export {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0 15px;
}

.select-box {
  margin-right: 10px;
  width: 100px;
}

.select-state-box {
  width: 130px;
}

.total-wrapper {
  display: flex;
  flex-direction: row;
  padding: 0 10px;
  margin-top: 10px;
  margin-left: 15px;
  width: 270px;
}

.total-left {
  color: #606266;
  font-size: 16px;
  text-align: left;
}

.total-right {
  color: red;
  font-size: 15px;
}

.export-left {
  width: 100%;
}

.table-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.export-wrapper {
  height: 40px;
  display: flex;
  align-items: center;
}

/deep/ .el-input__inner {
  height: 36px;
  line-height: 36px;
}
</style>
